export default "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADwAQCdASoQABAAAsBMJaQAAxZgk8V7YAAA/vXZIESHTfG10/infKIvdOgt6vPTB6KQviCn/J1vtPtA1gAAAA==";